import { useState } from 'react'
import { Link } from 'react-router-dom'
import { useForm } from 'react-hook-form'
import { ErrorMessage } from '@hookform/error-message'
import { gql, useMutation } from '@apollo/client'
import { v4 as uuidv4 } from 'uuid'
import clsx from 'clsx'

import { getStrengthCheckMessage } from '../utils'
import { FRONTEND_URL } from '../constants'

const ALLOW_REGISTER = gql`
  mutation AllowRegister($email: String!) {
    allowRegister(input: { email: $email }) {
      allow
      email
    }
  }
`
const REGISTER_USER = gql`
  mutation RegisterUser(
    $username: String!
    $firstName: String!
    $lastName: String!
    $nicename: String!
    $email: String!
    $password: String!
    $location: String!
  ) {
    registerUser(
      input: {
        username: $username
        firstName: $firstName
        lastName: $lastName
        nicename: $nicename
        email: $email
        location: $location
        password: $password
        points: 0
        completion: []
      }
    ) {
      user {
        id
      }
    }
  }
`
const SEND_WELCOME_EMAIL = gql`
  mutation SendWelcomeEmail($to: String!, $subject: String!, $body: String!) {
    sendEmail(input: { to: $to, subject: $subject, body: $body }) {
      origin
      sent
      message
    }
  }
`

const Register = () => {
  const [allowRegister] = useMutation(ALLOW_REGISTER)
  const [registerUser] = useMutation(REGISTER_USER)
  const [sendWelcomeEmailMutation] = useMutation(SEND_WELCOME_EMAIL)
  const {
    register,
    setValue,
    handleSubmit,
    setError,
    formState: { errors },
  } = useForm({
    mode: 'onTouched',
    criteriaMode: 'all',
  })
  const [registering, setRegistering] = useState(false)
  const [success, setSuccess] = useState(false)
  const [formMessage, setFormMessage] = useState('')

  const _sendWelcomeEmail = async (to) => {
    const copyrightYear = new Date().getFullYear()
    const subject = 'TMC Account Confirmation'
    const body = `
    <table style="max-width: 600px; margin: 0px auto;" border="0" width="90%" cellspacing="0" cellpadding="0">
      <tbody>
        <tr>
          <td style="padding: 33px 0px 18px 0px;" colspan="3" align="center" valign="top"><img src="https://smartfirm-tmc-assets.s3.amazonaws.com/email/EmailBanner_vTMC-01.jpg" alt="TMC" width="600" height="auto" border="0" /></td>
        </tr>
        <tr>
          <td
            style="padding: 0px 0px 18px 0px; color: #333333; font-family: Arial, Helvetica Neue, Helvetica, sans-serif; font-size: 17px; font-weight: 400; line-height: 25px; margin: 0; text-align: left;"
            align="center" valign="top">Thank you for creating your TMC website account! Please save your login details and bookmark the website as you will be returning to it frequently throughout the program.</td>
        </tr>
        <tr>
          <td
            style="padding: 0px 0px 18px 0px; color: #333333; font-family: Arial, Helvetica Neue, Helvetica, sans-serif; font-size: 17px; font-weight: 700; line-height: 25px; margin: 0; text-align: left;"
            align="center" valign="top">What's next?</td>
        </tr>
        <tr>
          <td
            style="padding: 0px 0px 18px 0px; color: #333333; font-family: Arial, Helvetica Neue, Helvetica, sans-serif; font-size: 17px; font-weight: 400; line-height: 25px; margin: 0; text-align: left;"
            align="center" valign="top">If you haven't already, be sure to read through the information on the website's homepage for program details.</td>
        </tr>
        <tr>
          <td
            style="padding: 0px 0px 18px 0px; color: #333333; font-family: Arial, Helvetica Neue, Helvetica, sans-serif; font-size: 17px; font-weight: 400; line-height: 25px; margin: 0; text-align: left;"
            align="center" valign="top">Additionally, click the profile icon in the top right corner and upload a photo of yourself for use on the leaderboard.</td>
        </tr>
        <tr>
          <td
            style="padding: 0px 0px 18px 0px; color: #333333; font-family: Arial, Helvetica Neue, Helvetica, sans-serif; font-size: 17px; font-weight: 400; line-height: 25px; margin: 0; text-align: left;"
            align="center" valign="top">If you want to get a head start on earning leaderboard points before you arrive, the Learning Lounge is available to you now.</td>
        </tr>
        <tr>
          <td
            style="padding: 0px 0px 18px 0px; color: #333333; font-family: Arial, Helvetica Neue, Helvetica, sans-serif; font-size: 17px; font-weight: 400; line-height: 25px; margin: 0; text-align: left;"
            align="center" valign="top">After that, all that’s left to do is get ready (and excited) to attend TMC where we have an engaging 3.5 days of in-person learning prepared for you.</td>
        </tr>
        <tr>
          <td
            style="padding: 0px 0px 18px 0px; color: #333333; font-family: Arial, Helvetica Neue, Helvetica, sans-serif; font-size: 17px; font-weight: 400; line-height: 25px; margin: 0; text-align: left;"
            align="center" valign="top"><strong>Questions?</strong> Contact <a
              href="mailto:training@protiviti.com">training@protiviti.com</a>.</td>
        </tr>
        <tr>
          <td style="padding: 12px 0px 36px 0px" align="center" valign="top">
            <table
              style="margin: 0 auto"
              border="0"
              cellspacing="0"
              cellpadding="0"
            >
              <tbody>
                <tr>
                  <td
                    style="border-radius: 4px"
                    align="center"
                    bgcolor="#d74b29"
                    width="315"
                  >
                    <a
                      style="
                        padding: 18px;
                        display: block;
                        text-decoration: none;
                        border: 1px solid #d74b29;
                        text-align: center;
                        font-size: 14px;
                        font-family: Arial, Helvetica Neue, Helvetica, sans-serif;
                        letter-spacing: 1px;
                        color: #ffffff;
                        background: #d74b29;
                        border-radius: 4px;
                        line-height: 17px;
                        text-transform: uppercase;
                        width: 315px;
                      "
                      href="${FRONTEND_URL}"
                      target="_blank"
                      rel="noopener"
                      >Take me there
                    </a>
                  </td>
                </tr>
              </tbody>
            </table>
          </td>
        </tr>
        <tr>
          <td
            style="padding: 24px 0px 18px 0px; color: #787676; font-family: Arial, Helvetica Neue, Helvetica, sans-serif; font-size: 13px; font-weight: 400; line-height: 19px; margin: 0;"
            colspan="3" align="center" valign="top">© ${copyrightYear} Protiviti, All rights reserved</td>
        </tr>
      </tbody>
    </table>
    `

    return sendWelcomeEmailMutation({
      variables: {
        to: to,
        subject: subject,
        body: body,
      },
    })
  }

  const onFormSubmit = async ({
    firstname = '',
    lastname = '',
    email = '',
    location = '',
    password = '',
  }) => {
    // TODO: To be removed in production
    // Temporary fix illegal character. + sign in this case.
    const username = email.replace(/\+/g, '')

    try {
      // Initially, mark success as `false`
      setSuccess(false)
      setRegistering(true)

      // Check if this email is allowed to register
      const allowRegisterResponse = await allowRegister({
        variables: {
          email: email,
        },
      })
      if (!allowRegisterResponse.data.allowRegister.allow) {
        setSuccess(false)
        setFormMessage('Email not recognized. Were you invited?')
        return
      }

      // Register the user
      await registerUser({
        variables: {
          clientMutationId: uuidv4(),
          username: username,
          firstName: firstname,
          lastName: lastname,
          email: email,
          location: location,
          password: password,
          nicename: `${firstname} ${lastname}`,
        },
      })

      // Send a welcome email
      const { data: sendEmailResponse } = await _sendWelcomeEmail(
        email,
        firstname
      )
      if (sendEmailResponse?.sendEmail?.sent === false) {
        console.error(
          'signup :: sendEmailResponse :: message ::',
          sendEmailResponse.sendEmail.message ?? 'no message'
        )
      }

      // Show the success message
      setSuccess(true)
      setFormMessage('Registration successful')
    } catch (err) {
      setSuccess(false)
      console.error('signup :: error', JSON.stringify(err))

      if (err.message?.includes('This username is already registered')) {
        setFormMessage('This username is already registered.')
      } else {
        setFormMessage('Unable to sign up! Please try again.')
      }
    } finally {
      setRegistering(false)
    }
  }

  return (
    <main className="min-h-[calc(100vh-200px)]">
      <div className="container pb-20 pt-2">
        <h1 className="mb-10 text-center text-4xl font-bold text-skin-accent">
          registration.
        </h1>
        <div className="mx-auto flex w-full flex-col sm:flex-row lg:w-[950px]">
          <div className="mx-auto flex min-h-[437px] basis-2/3 flex-col items-center divide-y divide-light-gray rounded-[19px] bg-white py-2 pb-10 shadow-lg lg:basis-1/2 [&>*]:px-6">
            {/** Header */}
            <div className="py-4 text-sm font-bold text-flame">
              Welcome to TMC!
            </div>

            <div className="w-full">
              {success ? (
                <div className="mb-4 mt-6 text-left">
                  <p className="font-bold">Next steps...</p>
                  <ol>
                    <li>Check your inbox for the welcome email; Or,</li>
                    <li>
                      Go to the{' '}
                      <Link to="/login" className="font-bold underline">
                        login page
                      </Link>{' '}
                      now.
                    </li>
                  </ol>
                </div>
              ) : (
                <div className="text-center">
                  <form
                    className={clsx(
                      'group mb-4 mt-6',
                      registering && 'registering'
                    )}
                    onSubmit={handleSubmit(onFormSubmit)}
                  >
                    <div
                      className={clsx(
                        'text-red-500 opacity-0 transition-opacity',
                        formMessage !== '' && 'mb-5 opacity-100'
                      )}
                    >
                      {formMessage}
                    </div>
                    {/** First name input */}
                    <fieldset className="mb-5">
                      <input
                        {...register('firstname', { required: true })}
                        name="firstname"
                        type="text"
                        placeholder="First Name*"
                        disabled={registering}
                        className={clsx(
                          'w-full rounded-[6.5px] placeholder-dark-gray',
                          errors.firstname
                            ? 'border-red-500'
                            : 'border-light-gray'
                        )}
                      />
                      <ErrorMessage
                        errors={errors}
                        name="firstname"
                        render={() => {
                          return (
                            <p className="text-left text-xs text-red-500">
                              This is required
                            </p>
                          )
                        }}
                      />
                    </fieldset>
                    {/** Last name input */}
                    <fieldset className="mb-5">
                      <input
                        {...register('lastname', { required: true })}
                        name="lastname"
                        type="text"
                        placeholder="Last Name*"
                        disabled={registering}
                        className={clsx(
                          'w-full rounded-[6.5px] border-light-gray placeholder-dark-gray',
                          errors.lastname
                            ? 'border-red-500'
                            : 'border-light-gray'
                        )}
                      />
                      <ErrorMessage
                        errors={errors}
                        name="lastname"
                        render={() => {
                          return (
                            <p className="text-left text-xs text-red-500">
                              This is required
                            </p>
                          )
                        }}
                      />
                    </fieldset>
                    {/** Email input */}
                    <fieldset className="mb-5">
                      <input
                        {...register('email', {
                          required: true,
                          pattern: /^\S+@\S+$/i,
                          // validate: {
                          //   notRecognized: (value) => validateEmail(value),
                          // },
                        })}
                        name="email"
                        type="email"
                        placeholder="Email*"
                        disabled={registering}
                        className={clsx(
                          'w-full rounded-[6.5px] border-light-gray placeholder-dark-gray',
                          errors.email ? 'border-red-500' : 'border-light-gray'
                        )}
                      />
                      <ErrorMessage
                        errors={errors}
                        name="email"
                        render={() => {
                          return (
                            <p className="text-left text-xs text-red-500">
                              This is required
                            </p>
                          )
                        }}
                      />
                    </fieldset>
                    {/** Local office input */}
                    <fieldset className="mb-5">
                      <input
                        {...register('location', { required: true })}
                        name="location"
                        type="text"
                        placeholder="Local Office (city)*"
                        disabled={registering}
                        className={clsx(
                          'w-full rounded-[6.5px] border-light-gray placeholder-dark-gray',
                          errors.location
                            ? 'border-red-500'
                            : 'border-light-gray'
                        )}
                      />
                      <ErrorMessage
                        errors={errors}
                        name="location"
                        render={() => {
                          return (
                            <p className="text-left text-xs text-red-500">
                              This is required
                            </p>
                          )
                        }}
                      />
                    </fieldset>
                    {/** Password input */}
                    <fieldset className="mb-5">
                      <input
                        {...register('password', {
                          required: true,
                          validate: {
                            strengthCheck: (value) => {
                              const { strength, message } =
                                getStrengthCheckMessage(value)

                              return strength === 'strong' ? true : message
                            },
                          },
                        })}
                        name="password"
                        type="password"
                        placeholder="Password*"
                        disabled={registering}
                        className={clsx(
                          'w-full rounded-[6.5px] border-light-gray placeholder-dark-gray',
                          errors.password && 'border-red-500'
                        )}
                        onChange={({ target: { value } }) => {
                          const { message } = getStrengthCheckMessage(value)
                          setError('password', {
                            type: 'info',
                            message,
                          })
                        }}
                        onKeyPress={({ key, target: { value } }) => {
                          // React hook form doesn't capture input value yet. So, we have to manually set it in order for the form validation to work properly.
                          if (key === 'Enter') {
                            setValue('password', value)
                          }
                        }}
                      />
                      <ErrorMessage
                        errors={errors}
                        name="password"
                        render={({ message }) => {
                          return errors.password.type === 'required' ? (
                            <p className="text-left text-xs text-red-500">
                              This is required
                            </p>
                          ) : (
                            <div
                              className="text-left text-xs"
                              dangerouslySetInnerHTML={{
                                __html: message,
                              }}
                            />
                          )
                        }}
                      />
                    </fieldset>
                    {/** Register button */}
                    <input
                      type="submit"
                      value={registering ? 'registering...' : 'register'}
                      disabled={registering}
                      className="w-full cursor-pointer rounded-full bg-skin-button-accent px-6 pb-3 pt-[0.6rem] font-bold text-white transition-colors group-[.registering]:cursor-not-allowed group-[.registering]:opacity-50 group-[:not(.registering)]:hover:bg-skin-button-accent-hover group-[:not(.registering)]:active:translate-y-[0.75px] group-[:not(.registering)]:active:scale-[0.99]"
                    />
                  </form>
                  {/** Forgot password link */}
                  <Link
                    to="/forgot"
                    className={clsx(
                      'text-xs text-silver-chalice hover:underline group-[.registering]:cursor-not-allowed',
                      registering && 'pointer-events-none opacity-50'
                    )}
                  >
                    Forgot your password?
                  </Link>
                </div>
              )}
            </div>
          </div>
          <div className="order-first mb-8 ml-0 basis-1/3 sm:order-none sm:mb-0 sm:ml-[50px] lg:ml-[120px] lg:mt-[40px] lg:basis-1/2">
            <p className="text-2xl font-bold leading-normal">
              on your marks, get set, go!
            </p>
            <p>
              Complete the registration fields to the left to create your TMC
              website account. Once you register, you will receive a
              confirmation email with further program details and next steps.
            </p>
            <p>
              Remember to access your profile in the upper right to upload a
              profile photo for use on the leaderboard!
            </p>
          </div>
        </div>
      </div>
    </main>
  )
}

export default Register
